// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table thead tr th[data-v-3b88e930]{border:0}table thead tr th.header-table-color[data-v-3b88e930]{background-color:#f2f2f2!important;color:#9e9d9d!important;font-weight:500}table tbody tr td[data-v-3b88e930]{font-size:12px;border:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
